import type { PageResult } from '@jiaofa/api-types'
import { request } from './request'

export interface VerificationLog {
  id: string
  verifyNo?: string
  code: string
  bizType?: string
  orderId?: string
  orderNo?: string
  storeId?: string
  storeName?: string
  userId?: string
  userNickname?: string
  result: string
  failReason?: string
  createdAt?: string
}

export interface VerificationLogsParams {
  page?: number
  pageSize?: number
  code?: string
  orderNo?: string
  result?: string
}

export interface VerificationPayload {
  verifyCode: string
  orderId?: string
}

export const verificationApiReady = true as const

export const fetchVerificationLogs = async (
  params: VerificationLogsParams,
): Promise<PageResult<VerificationLog>> =>
  request<PageResult<VerificationLog>>({
    url: '/verification/logs',
    method: 'GET',
    params,
  })

export const verifyOrder = async (payload: VerificationPayload): Promise<void> =>
  request<void, VerificationPayload>({
    url: '/verification/verify',
    method: 'POST',
    data: payload,
  })
